import React, { useState, useEffect } from "react";
import Transition from "../../../components/Transition";
import { Link } from "react-router-dom";
import { useAppContext } from "../../../context/AppContext";
import { LogoutUser } from "../../auth/network/api/LogoutUser";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader";
import Error from "../../error";
import { encodeId } from "../../../utils/hash";
import { AnimatePresence } from "framer-motion";
import UserEmailVerification from "./UserEmailVerification";
import AppAnnouncementsBanner, { AppAnnouncementsMenu } from "./AppAnnouncements";


export default function UserPageLayout({ children }) {
    const {
        setIsLoggedIn,
        appData,
        updateUserData,
        userAccessData,
        pageTitle,
        pageUserID,
        announcements,
        areAnnouncementsLoading,
    } = useAppContext();
    const [loggedInUserData, setLoggedInUserData] = useState(null);
    const [isAdminSession, setIsAdminSession] = useState(false);

    useEffect(() => {
        const raw = localStorage.getItem("userData");
        const userData = raw ? JSON.parse(raw) : null;

        setLoggedInUserData(userData);

    }, [updateUserData]);


    useEffect(() => {
        setIsAdminSession(false);
        if (pageUserID && loggedInUserData) {
            const userId = loggedInUserData?.user?.userId;
            if (Number(userId) !== Number(pageUserID)) {
                setIsAdminSession(true);
            } else {
                setIsAdminSession(false);
            }
        } else {
            setIsAdminSession(false);
        }

    }, [pageUserID, loggedInUserData]);


    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [errorStatus, setErrorStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const handleLogout = async (e) => {

        setErrorMessage(null);
        setIsLoading(true);
        e.preventDefault();

        const response = await LogoutUser();
        if (response.status === "success") {

            setIsLoading(false);
            localStorage.removeItem("userData");
            setIsLoggedIn(false);
            navigate("/");

        } else {
            setIsLoading(false);
            setErrorStatus(response.status);
            setErrorMessage(response.message);
            navigate("/login");
        }


    }

    if (!isLoading && Boolean(loggedInUserData?.user?.email_verified) === false) {
        return (<UserEmailVerification email={loggedInUserData?.user?.email} handleLogout={handleLogout} />);
    }


    if (errorMessage && !isLoading) {
        return (
            <div className="authincation h-100">
                <Error
                    code={errorStatus}
                    message={errorMessage}
                />
            </div>
        );
    }

    return (
        <div id="main-wrapper" key={`main-user-wrapper`}>
            {isLoading && (
                <div className="app-preloader" aria-busy="true">
                    <Loader />
                </div>
            )}
            {!isLoading && loggedInUserData?.user?.email_verified === true && (<>
                <div className="nav-header">
                    <Link to="/home" className="brand-logo" reloadDocument="true" replace="true">

                        <img className="logo-abbr" src={appData.logo} alt="Logo" width="60" />

                        <div className="brand-title text-primary"   >
                            CRM
                        </div>
                    </Link>
                    <div className="nav-control">
                        <div className="hamburger">
                            <span className="line"></span><span className="line"></span><span className="line"></span>
                        </div>
                    </div>
                </div>

                <div className="header" >

                    <div
                        className={`header-content ${isAdminSession && "bg-danger"}`}
                        style={{
                            ...(isAdminSession ? { height: '80px' } : {})
                        }}
                    >
                        <nav className="navbar navbar-expand">
                            <div className="collapse navbar-collapse justify-content-between">
                                <div className="header-left">
                                    <div className={`${isAdminSession ? "text-white" : ""} dashboard_bar`}>{pageTitle} </div>

                                </div>
                                <ul className="navbar-nav header-right">
                                    <li className="nav-item">
                                        <div className="input-group search-area">
                                            <input type="text" className="form-control" placeholder="Search here" />
                                            <span className="input-group-text">
                                                <span type="button" className="btn-icon">
                                                    <i className="flaticon-381-search-2"></i>
                                                </span>
                                            </span>
                                        </div>
                                    </li>

                                    <li className="nav-item dropdown notification_dropdown">
                                        <button className="nav-link bell dz-theme-mode">
                                            <i id="icon-light" className="fas fa-sun"></i>
                                            <i id="icon-dark" className="fas fa-moon"></i>
                                        </button>
                                    </li>

                                    <AppAnnouncementsMenu
                                        announcements={announcements}
                                        isLoading={areAnnouncementsLoading}
                                    />

                                    {userAccessData.super_user ?
                                        <li className="nav-item dropdown notification_dropdown">
                                            <Link to="/admin" className="nav-link bell-link ai-icon" >
                                                <i id="" className="fas  fa-user-secret"></i>
                                                <div className="pulse-css"></div>
                                            </Link>
                                        </li> : <></>}

                                    <li className="nav-item dropdown header-profile ">
                                        <button className="nav-link text-start" data-bs-toggle="dropdown">
                                            <img src={loggedInUserData?.user?.avatar || "https://img.freepik.com/premium-vector/profile-picture-placeholder-avatar-silhouette-gray-tones-icon-colored-shapes-gradient_1076610-40164.jpg"}
                                                onError={(e) => { e.target.onerror = null; e.target.src = "https://img.freepik.com/premium-vector/profile-picture-placeholder-avatar-silhouette-gray-tones-icon-colored-shapes-gradient_1076610-40164.jpg"; }} alt="User Avatar" />
                                            <div className="header-info ms-3 ">
                                                <span className={(isAdminSession && "text-white") || ""}>{loggedInUserData?.user?.userName}</span>
                                                <small className={(isAdminSession && "text-light") || ""}>{loggedInUserData?.user?.authority?.join(" / ")}</small>
                                            </div>
                                        </button>
                                        <div className="dropdown-menu dropdown-menu-end">
                                            <Link to={`/users/${encodeId(loggedInUserData?.user?.userId)}/profile`} className="dropdown-item ai-icon" >
                                                <svg id="icon-user1" xmlns="http://www.w3.org/2000/svg" className="text-primary" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                                    <circle cx="12" cy="7" r="4" />
                                                </svg>
                                                <span className="ms-2">Profile</span>
                                            </Link>

                                            <button onClick={handleLogout} className="dropdown-item ai-icon"   >
                                                <svg id="icon-logout" xmlns="http://www.w3.org/2000/svg" className="text-danger" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                                    <polyline points="16 17 21 12 16 7" />
                                                    <line x1="21" y1="12" x2="9" y2="12" />
                                                </svg>
                                                <span className="ms-2">Logout</span>
                                            </button>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                    {isAdminSession && (
                        <AnimatePresence mode="wait">
                            <Transition key={"admin-session"}>
                                <div className="bg-danger" style={{

                                    color: 'white',
                                    textAlign: 'center',
                                    padding: '6px 12px',
                                    fontWeight: 'bold',
                                    fontSize: '12px',

                                    borderBottomLeftRadius: '15px',
                                    borderBottomRightRadius: '15px',
                                    marginLeft: 0
                                }}>
                                    <span className="d-none d-md-block text-white">
                                        <i className="fa fa-info-circle"></i>{" "}
                                        You are in Admin Session - Viewing Another User's Account
                                    </span>
                                </div>
                            </Transition>
                        </AnimatePresence>)}

                    <AppAnnouncementsBanner announcements={announcements} />
                </div>

                <div className="deznav">
                    <div className="deznav-scroll">
                        <ul className="metismenu" id="menu">

                            <li>
                                <Link to="/home" className="ai-icon" aria-expanded="false" >
                                    <i className="flaticon-025-dashboard"></i>
                                    <span className="nav-text">Dashboard</span>
                                </Link>
                            </li>
                            {userAccessData.super_user ?
                                <li>
                                    <a className="has-arrow" aria-expanded="false" href="/" onClick={(e) => e.preventDefault()}>
                                        <i className="fas fa-user-secret"></i>
                                        <span className="nav-text">Admin</span>
                                    </a>
                                    <ul >
                                        <li><Link to="/admin">Dashboard</Link></li>
                                        <li><Link to="/users">Users</Link></li>
                                        <li><Link to="/announcements">Announcements</Link></li>
                                        <li><Link to="/articles">Articles</Link></li>
                                        <li>
                                            <a className="has-arrow " aria-expanded="false" href="/" onClick={(e) => e.preventDefault()}>
                                                Shop
                                            </a>
                                            <ul className="left mm-collapse">
                                                <li><Link to="/orders">Orders</Link></li>
                                                <li><Link to="/products">Products</Link></li>
                                            </ul>
                                        </li>
                                        {appData?.metadata?.features?.includes("affiliate") && (
                                            <>
                                                <li><Link to="/admin/partners">Partners</Link></li>
                                                <li><Link to="/withdrawals">Withdrawals</Link></li>
                                            </>
                                        )}
                                        {appData?.metadata?.features?.includes("brokers") && (
                                            <li><Link to="/brokers">Brokers</Link></li>
                                        )}
                                        <li><Link to="/logs">System Logs</Link></li>
                                    </ul>
                                </li>
                                : <></>
                            }
                            {appData?.metadata?.features?.includes("affiliate") && (
                                <li>
                                    <a className="has-arrow " aria-expanded="false" href="/" onClick={(e) => e.preventDefault()}>
                                        <i className="fas fa-handshake" aria-hidden="true"></i>
                                        <span className="nav-text">Partner</span>
                                    </a>
                                    <ul >
                                        <li><Link to="/partner">Dashboard</Link></li>
                                        <li><Link to="/earnings">Earnings</Link></li>
                                    </ul>
                                </li>
                            )}
                            <li>
                                <Link className="ai-icon" to={`/users/${encodeId(loggedInUserData?.user?.userId)}/eas`} aria-expanded="false">
                                    <i className="fas fa-robot"></i>
                                    <span className="nav-text">Manage EAs</span>
                                </Link>
                            </li>
                            {appData?.metadata?.features?.includes("shop") && (
                                <li>
                                    <Link to="/shop" className="ai-icon" aria-expanded="false" >
                                        <i className="fa fa-shopping-bag" aria-hidden="true"></i>
                                        <span className="nav-text">Shop</span>
                                    </Link>
                                </li>
                            )}
                            <li>
                                <Link to={`/users/${encodeId(loggedInUserData?.user?.userId)}/profile`} className="ai-icon" aria-expanded="false" >
                                    <i className="fa fa-user" aria-hidden="true"></i>
                                    <span className="nav-text">Profile</span>
                                </Link>
                            </li>

                            <li>
                                <Link to={"/help"} className=" ai-icon" >
                                    <i className="fa fa-question-circle"></i>
                                    <span className="nav-text">Help</span>
                                </Link>

                            </li>

                            <li>
                                <Link to={"/legal"} className="ai-icon">
                                    <i className="fas fa-legal"></i>
                                    <span className="nav-text">Legal</span>
                                </Link>
                            </li>
                            <li>
                                <a href="/" onClick={handleLogout} className="ai-icon"  >
                                    <i className="fas fa-sign-out-alt"></i>
                                    <span className="nav-text">Logout</span>
                                </a>
                            </li>


                        </ul>
                        <div className="copyright">

                            <p><strong>{appData.name} Admin</strong> &copy; {new Date().getFullYear()} All Rights Reserved</p>

                        </div>
                    </div>

                </div>
                <AnimatePresence mode="wait">
                    <Transition key={"user-page-layout"}>
                        {children}


                        <div className="footer">

                            <div className="copyright">

                                <p>&copy; {new Date().getFullYear()} {pageTitle} · {appData?.name}. All rights reserved. </p>
                            </div>
                        </div>
                    </Transition>
                </AnimatePresence>
            </>)}

        </div>


    );
}
